import {NodePropertiesPane} from '../../SidePanel/RightPanel/NodePane.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Model from './ModelOld.mjs'
import OldType from './OldType.jsx'

const PropertiesPaneOld = (props) => (
    <NodePropertiesPane
        Model={Model}
        {...props}
    >
        <Text prop="text" />

        <Select
            options={OldType}
            prop="type"
        />
    </NodePropertiesPane>
)

export default PropertiesPaneOld
